import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import {
  applyOrCreateTabOnPostTradeTabsFetchedEpic,
  applyOrCreateTabOnTabsFetchedEpic,
  deleteTabsDescriptionOnAllTabsRemovedEpic,
  fetchTabContentEpic,
  fetchTabContentOnTabActivatedEpic,
  persistTabsDescriptionOnWorkspaceTabsUpdatedEpic,
  workspaceTabPersistAssociatedQuoteEpic,
} from './tabs/tabsEpics';
import {
  addOpenedProductToRecentProductsReferentialEpic,
  fetchRecentProductsReferentialEpic,
  loadFromLocalStorageEpic,
  saveToLocalStorageEpic,
} from './workspaces';

export const workspaceCommonEpic = () =>
  withAppCrashIfException(
    'workspaceCommon',
    combineEpics(
      withAppCrashIfException('applyOrCreateTabOnTabsFetchedEpic', applyOrCreateTabOnTabsFetchedEpic()), // no async, could be a thunk
      withAppCrashIfException(
        'applyOrCreateTabOnPostTradeTabsFetchedEpic',
        applyOrCreateTabOnPostTradeTabsFetchedEpic(),
      ),
      withAppCrashIfException('deleteTabsDescriptionOnAllTabsRemovedEpic', deleteTabsDescriptionOnAllTabsRemovedEpic()), // OK
      withAppCrashIfException('fetchTabContentOnTabActivatedEpic', fetchTabContentOnTabActivatedEpic()), // OK
      withAppCrashIfException('fetchTabContentEpic', fetchTabContentEpic()), // OK
      withAppCrashIfException(
        'persistTabsDescriptionOnWorkspaceTabsUpdatedEpic',
        persistTabsDescriptionOnWorkspaceTabsUpdatedEpic(),
      ), // OK
      withAppCrashIfException('quoteChangeTriggerTabPersistenceEpic', workspaceTabPersistAssociatedQuoteEpic()),
      withAppCrashIfException('loadFromLocalStorageEpic', loadFromLocalStorageEpic()),
      withAppCrashIfException('saveToLocalStorageEpic', saveToLocalStorageEpic()),
      withAppCrashIfException('fetchRecentProductsReferentialEpic', fetchRecentProductsReferentialEpic()),
      withAppCrashIfException(
        'addOpenedProductToRecentProductsReferentialEpic',
        addOpenedProductToRecentProductsReferentialEpic(),
      ),
    ),
  );
